module.exports = __webpack_public_path__ + "img/wichum.80dc9ac2.jpeg";